// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2nNY4","header":"ReportDetails_header__3f6yo","title":"ReportDetails_title__1sTE0","left":"ReportDetails_left__34BJr"};